import {observable} from 'mobx';
import {createInstance} from 'utils';
import {WebLocaleKey} from './web-locale-key';
import {WebLocaleContent} from './web-locale-content';

export class WebLocale extends WebLocaleKey {
    @observable id!: number;
    @observable initialContent = '';
    @observable motherContent?: WebLocaleContent;
    @observable targetContent?: WebLocaleContent;

    constructor(translation?: WebLocale) {
        super(translation);
        if (translation) {
            this.id = translation.id;
            this.motherContent = createInstance(WebLocaleContent, translation.motherContent);
            this.targetContent = createInstance(WebLocaleContent, translation.targetContent);
            if (this.targetContent) {
                this.initialContent = this.targetContent.contentEdited;
            }
        }
    }
}